// extracted by mini-css-extract-plugin
export default {"bluebook-tooltip-container":"bluebook-tooltip-container-Cqqm7","bluebook-tooltip-arrow":"bluebook-tooltip-arrow-I9l8m"};